import { observable, action } from 'mobx';
import agent from '../services/web/agent';
import passwordMatchValidator from '../services/validations/passwordMatchValidator';
import { setter } from 'mobx-decorators';

export default new class ChangePasswordStore {

  @observable errors = null;
  @observable isError = null;
  @observable changingPassword;
  @observable changingMyPasswordProgress = false;
  @observable errorMessage = null;
    @observable isPasswordExpired = false;
    @observable oldPasswordValidationMessage;
    @observable newPasswordValidationMessage;
   
  @setter @observable username = window.sessionStorage.getItem('username');
  @setter @observable tenant = window.sessionStorage.getItem('tenant');

  @observable oldPassword = '';
  @observable newPassword = '';
  @setter @observable passwordChangedSuccessfully = false;

  formErrors = [];

  validateOldPassword() {

    const result = passwordMatchValidator.validatePasswordBase(this.oldPassword);

    this.oldPasswordValidationMessage = result.passwordValidationMessage;

    this.formErrors.push(result.validation.errorCount);
}

  validatePassword() {

      const result = passwordMatchValidator.validatePassword(this.newPassword);

      this.newPasswordValidationMessage = result.passwordValidationMessage;

      this.formErrors.push(result.validation.errorCount);
  }

  @action validateForm() { 

    this.formErrors = [];
    this.validateOldPassword();
    this.validatePassword();

    const hasError = this.formErrors.filter((valid) => valid > 0).length > 0;

    if (hasError === true) {

        return false;
    }

    return true;
  }

  @action changePassword() {
      
      this.changingPassword = true;
      this.formErrors = [];
      this.passwordChangedSuccessfully = false;

      this.validateForm();

      const hasError = this.formErrors.filter((valid) => valid > 0).length > 0;
      if (hasError === true){
          return;   
      }

      return agent.Users
              .changePassword(this.username, this.tenant, this.oldPassword, this.newPassword)
              .then(action(_ => {
                window.sessionStorage.removeItem('username');
                window.sessionStorage.removeItem('tenant');
                }))
              .catch(action((err) => {

                  this.changingPassword = false;

                  if (err && err.response && err.response.text) {
              
                    this.isError = true;
                    this.errorMessage = JSON.parse(err.response.text).Message;
                  }

                  this.errors = err.response && err.response.body && err.response.body.errors;
                  throw err;
                }));
    }

  @action changeMyPassword() {

      this.formErrors = [];
      this.passwordChangedSuccessfully = false;
      this.changingMyPasswordProgress = true;
      
      this.validateForm();

      const hasError = this.formErrors.filter((valid) => valid > 0).length > 0;

      if (hasError === true){
          
        return;
      }

      return agent.Users
          .changeMyPassword(this.oldPassword, this.newPassword)
          .catch(action((err) => {

              if (err && err.response && err.response.text) {
          
                this.isError = true;
                this.errorMessage = JSON.parse(err.response.text).Message;
              }

              this.errors = err.response && err.response.body && err.response.body.errors;
              throw err;
            }))
            .finally(action(() => {

              this.changingMyPasswordProgress = false;
            }));
  }

  @action setUsername = (username) => {

    this.username = username;
    window.sessionStorage.setItem('username', username);
  }

    @action setIsPasswordExpired = (expired) => {

        this.isPasswordExpired = expired;
    }
  @action setTenant = (tenant) => {

    this.tenant = tenant;
    window.sessionStorage.setItem('tenant', tenant);
  }

  @action setOldPassword(oldPassword) {

    this.oldPassword = oldPassword;
  }

  @action setNewPassword(newPassword) {

    this.newPassword = newPassword;
  }

  @action resetForm() {

    this.oldPassword = '';
    this.newPassword = '';
  }

  @action resetValidations() {

      this.formErrors = [];
      this.errorMessage = '';
      this.oldPasswordValidationMessage = '';
      this.newPasswordValidationMessage = '';
  }
};